import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { capitalizeWords } from '../../utils/helper';

export const CreateTableHeader = ({ tableCell }: { tableCell: any[] }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        border: '1px solid #8A8D91',
        borderRadius: 2,
        overflow: 'hidden',
        height: 100, // ensures rounded corners are visible
      }}
    >
      <Table>
        <TableHead
          sx={{
            backgroundColor: '#1C1C1C', // ✅ this now applies correctly
          }}
        >
          <TableRow>
            {tableCell.map((cellValue, index) => (
              <TableCell
                key={index}
                sx={{
                  borderBottom: 'none',
                  width: cellValue[1],
                  textAlign: 'center',
                  color: '#FFFFFF',
                  border: '1px solid red',
                }}
              >
                <strong>{capitalizeWords(cellValue[0])}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      </Table>
    </TableContainer>
  );
};
